import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ProfilePersonalInfo from "./ProfilePersonalInfo";
import ProfileSecurityInfo from "./ProfileSecurityInfo";
import ProfileContainer from "./ProfileContainer";
import {AccountCircle, Security} from "@mui/icons-material";
import {Box} from "@mui/system";
import ProfileSubscription from "./ProfileSubscription";

const Profile = () => {

    return (
        <Grid2 container spacing={2} justifyContent={"center"}>

            {/*subscribe*/}
            <Grid2 xs={12} md={5} lg={3}>
                <ProfileSubscription/>
            </Grid2>

            {/*personal and security*/}
            <Grid2 xs={12} md={7} lg={9}>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2,}}>
                    {/*personal information*/}
                    <ProfileContainer
                        title="اطلاعات شخصی"
                        icon={<AccountCircle sx={{color: "#BDBDBD", fontSize: "28px"}}/>}
                    >
                        <ProfilePersonalInfo/>
                    </ProfileContainer>

                    {/*security*/}
                    <ProfileContainer
                        title="امنیت"
                        icon={<Security sx={{color: "#BDBDBD", fontSize: "28px"}}/>}
                    >
                        <ProfileSecurityInfo/>
                    </ProfileContainer>
                </Box>
            </Grid2>

        </Grid2>
    );
};

export default Profile;
